import { Skeleton, SkeletonProps } from '@dixa/lib-shared-habla';

export const TextPlaceholder = <
  TElementType extends keyof JSX.IntrinsicElements,
>({
  ...rest
}: SkeletonProps<TElementType>): JSX.Element => {
  return <Skeleton height="14px" {...rest} />;
};
